export default __webpack_public_path__ + "static/media/text-invite.2ac0d841.svg";